import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { Page } from 'layout'
import { SmartFilter, SmartFilterValues } from 'components/common'

import { TenantCategoryActions } from 'models/TenantCategory/slice'
import { TenantCategoryList, TenantCategoryForm } from 'models/TenantCategory/components'


const filterFields = [
  SmartFilter.getFieldConfig('isActive', 'Активно', SmartFilter.FilterBool),
];


const TenantCategoryListPage = () => {
  const dispatch = useDispatch();

  const [params, setParams] = useState(null);

  const onEdit = () => {
    dispatch(TenantCategoryActions.openForm({ name: 'editForm' }))
  };
 
  const onFilterChange = (params) => {
    setParams(params)
  }

  return (
    <Page
      title="Категории арендаторов"
      headerMiddle={<SmartFilter queryKey="tenantCategory" onChange={onFilterChange} fields={filterFields} />}

      mainActions={[
        { name: 'add', action: (detail) => onEdit() },
      ]}

      basePath="/tenant/"
      tabs={[
        { label: 'Арендаторы', key: '' },
        { label: 'Категории', key: 'category/' },
        { label: 'Услуги', key: 'service/' },
      ]}
    >
      <SmartFilterValues queryKey="tenantCategory" onChange={onFilterChange} fields={filterFields} />

      <TenantCategoryList params={params} />

      <TenantCategoryForm mode="list" />
    </Page>
  )
}

export default TenantCategoryListPage
